var $dd0d25f885b5c5f3$exports = {};
$dd0d25f885b5c5f3$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Selector de color`,
    "colorSwatch": `muestra de color`,
    "transparent": `transparente`,
    "twoDimensionalSlider": `Regulador 2D`
};


export {$dd0d25f885b5c5f3$exports as default};
//# sourceMappingURL=es-ES.module.js.map
